module.exports = __webpack_public_path__ + "img/singapore.deda0817.svg";